<div class="d-flex justify-content-between flex-wrap w-100 mb-2 tabset-header">
    <div class="nav-tabs-container mb-2 mb-lg-0">
        <ul class="nav nav-tabs">
            <li *ngIf="isBackButtonShown" class="d-flex flex-column justify-content-center">
                <button type="button" class="btn btn-secondary tabset-back-btn me-2" (click)="onButtonClicked.emit()" data-uit="tabset-back-btn">
                    <ca-icon name="arrow-left" size="s" class="me-2"></ca-icon>{{ 'GENERAL.BACK' | translate }}
                </button>
            </li>
            <li
                *ngFor="let tab of tabs"
                class="btn tab-selector {{ tab.tabId }} me-4"
                [class.active]="tab.active"
                [caWidth]="(tabsWidth ?? 130) + 'px'"
                attr.data-uit="page-tab-selector-{{ tab.tabId }}"
            >
                <button type="button" class="btn btn-link" (click)="selectTab(tab.tabId)">{{ tab.tabTitle }}</button>
            </li>
            <!-- dynamic tabs -->
            <li *ngFor="let tab of dynamicTabs" class="btn tab-selector {{ tab.tabId }} me-4" [class.active]="tab.active">
                <button type="button" class="btn btn-link" (click)="selectTab(tab.tabId)">{{ tab.tabTitle }}</button>
                <button type="button" class="btn ca-btn-icon" *ngIf="tab.isCloseable" (click)="closeTab(tab)">
                    <ca-icon name="something"></ca-icon>
                </button>
            </li>
        </ul>
    </div>
    <ng-content select="[header]" class="d-flex w-100 justify-content-end"></ng-content>
</div>
<ng-content></ng-content>
<ng-template ca-dynamic-tabs #container></ng-template>
